module.exports = __webpack_public_path__ + "static/media/editLogIcon.572cef07.svg";